import { useHistory } from 'react-router';

import { updateModalState } from 'actions/rekycVerification';
import { postMessageToMobileApp } from 'components/app/helpers';
import { COUNTRIES_WITH_NON_VERIFICATION } from 'constants/constants';
import { POST_MESSAGE_TO_MOBILE_EVENTS } from 'constants/enums';
import { RENEW_KYC_SELFIE_VERIFICATION_ENABLED } from 'constants/featureFlag';
import { MIXPANEL_EVENT_NAMES } from 'constants/mixpanelEventNames';
import { IS_REKYC_SELFIE_VERIFICATION_NATIVE_SUPPORTED } from 'constants/rnApp';
import routes from 'constants/routes';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import {
  isKycRefreshRequiredSelector,
  selectUserCountry,
} from 'selectors/otherSelectors';
import { useAppDispatch, useAppSelector } from 'storeHooks';
import StoreProxy from 'storeProxy';

const DEFAULT_OPTIONS = { trackMixpanel: true };
const useRekycVerificationNavigation = (
  source?: string,
  country?: string,
  options: { trackMixpanel: boolean } = DEFAULT_OPTIONS
) => {
  const appDispatch = useAppDispatch();

  const history = useHistory();

  const isKycRefreshRequired = useAppSelector(isKycRefreshRequiredSelector);

  /**
   * Navigates to the appropriate identity verification route based on the country.
   * Redirects to a specific tab if the country requires non-standard verification.
   */
  const navigateToIdVerification = () => {
    const userCountry = country ?? selectUserCountry(StoreProxy.getState());
    if (COUNTRIES_WITH_NON_VERIFICATION.includes(userCountry)) {
      history.push(`${routes.account.identityVerification}?tab=institution`);
    } else {
      history.push(routes.account.identityVerification);
    }
  };

  const navigateToVerification = () => {
    if (RENEW_KYC_SELFIE_VERIFICATION_ENABLED && isKycRefreshRequired) {
      if (IS_REKYC_SELFIE_VERIFICATION_NATIVE_SUPPORTED) {
        postMessageToMobileApp(
          POST_MESSAGE_TO_MOBILE_EVENTS.LAUNCH_NATIVE_REKYC_SELFIE_VERIFICATION,
          { source: source || '' }
        );
      } else {
        appDispatch(
          updateModalState({
            value: true,
            source: source || '',
          })
        );
      }
    } else {
      navigateToIdVerification();
      if (options?.trackMixpanel) {
        trackMixpanelEvent(MIXPANEL_EVENT_NAMES.ACCOUNT.IDENTITY_VERIFICATION.ALL_PAGES, {
          source: source || '',
        });
      }
    }
  };

  return {
    navigateToVerification,
  };
};

export { useRekycVerificationNavigation };
